import { Outlet,useLocation } from 'react-router-dom';
import { useState,useEffect } from 'react';

export default function ProductCarbonFootprint(){
// const [ itemObj , setItemObj] = useState({}); //設定當前點了table哪一筆tr物件(CRUD)

    return (
    <Outlet context={{
        // itemObj,setItemObj,
        // action,setAction,
        // currentStatus,setCurrentStatus,
        // setTab1Action,tab1Action,
        // currentComSeq, setCurrentComSeq, 
        // setReportListObj, reportListObj 
    }} />

    )
}
